import * as React from 'react';

import {useMutation} from '@apollo/react-hooks';

import {Button} from 'shells/button/button';

import type {
    CancelDripSequence as CancelDripSequenceMutation,
    CancelDripSequenceVariables as CancelDripSequenceMutationVariables,
    RetireDripSequence as RetireDripSequenceMutation,
    RetireDripSequenceVariables as RetireDripSequenceMutationVariables,
} from 'nutshell-graphql-types';

import {CancelSequenceModal} from './cancel-drip-sequence-modal/cancel-sequence-modal';
import DRIP_SEQUENCE_CANCEL from './graphql/mutations/drip-sequence-cancel.graphql';
import DRIP_SEQUENCE_RETIRE from './graphql/mutations/drip-sequence-retire.graphql';

type Props = {
    disabled: boolean;
    dripSequenceId: string;
    recipientCount: number;
    onCanceled: () => void;
    isCancelOnly?: boolean;
};

export function CancelSequenceButton(props: Props) {
    const [isCancelModalOpen, setIsCancelModalOpen] = React.useState<boolean>(false);

    const [retireDripSequence] = useMutation<
        RetireDripSequenceMutation,
        RetireDripSequenceMutationVariables
    >(DRIP_SEQUENCE_RETIRE);

    const [cancelDripSequence] = useMutation<
        CancelDripSequenceMutation,
        CancelDripSequenceMutationVariables
    >(DRIP_SEQUENCE_CANCEL);

    return (
        <>
            <Button
                disabled={props.disabled}
                variant='secondary'
                size='big'
                onClick={() => {
                    setIsCancelModalOpen(true);
                }}
            >
                Cancel sequence
            </Button>
            {isCancelModalOpen ? (
                <CancelSequenceModal
                    recipientCount={props.recipientCount}
                    onClose={() => setIsCancelModalOpen(false)}
                    onCancelSequence={() => {
                        return cancelDripSequence({
                            variables: {
                                input: {
                                    dripSequenceId: props.dripSequenceId,
                                },
                            },
                        });
                    }}
                    onRetireSequence={() => {
                        return retireDripSequence({
                            variables: {
                                input: {
                                    dripSequenceId: props.dripSequenceId,
                                },
                            },
                        });
                    }}
                    onComplete={() => {
                        props.onCanceled();
                        setIsCancelModalOpen(false);
                    }}
                    isCancelOnly={props.isCancelOnly}
                />
            ) : undefined}
        </>
    );
}
